import request from '@/utils/request';
export function getDataByStratigraphy() {
  return request.get(`/Cyclic/findAlldata`);

}
